import { PRIVATE_ROOT } from 'portal-modules/common/constants/urls'
const LEASE_OPTIONS = `${PRIVATE_ROOT}/lease-options`

export const TRANSFER = `${LEASE_OPTIONS}/transfer`
export const ADD_TRANSFER = `${LEASE_OPTIONS}/add-transfer`
export const TRANSFER_REQUEST_REJECTED = `${LEASE_OPTIONS}/transfer-request-rejected`
export const TRANSFER_REQUEST_ACCEPTED = `${LEASE_OPTIONS}/transfer-request-accepted`
export const TRANSFER_REQUEST_OPEN = `${LEASE_OPTIONS}/transfer-request-open`
